import { render, staticRenderFns } from "./ChatAvatar.vue?vue&type=template&id=079cb5f9&scoped=true&"
import script from "./ChatAvatar.vue?vue&type=script&lang=js&"
export * from "./ChatAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079cb5f9",
  null
  
)

export default component.exports